const ON_CHANGE_DEBOUNCE_TIMER = 300;

/* Ported from Etoile-Ho/gumode_shopify_theme at fd819271. */
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
